import React from "react";
import { injectIntl } from "react-intl";
import { useDispatch } from "react-redux";
import { useLocation, useNavigate } from "react-router-dom";
import videopacientefrente from "../../assets/videos/paciente-frente.mp4";
import NextButton from "../../components/NextButton";
import ScenarioBar from "../../components/ScenarioBar";
import { ROUTES } from "../../utils/constants";
import { getScenarioNumByPath } from "../../utils/helpers";
import { IconActivity } from "@tabler/icons-react";

function Scenario5Intro({ intl }) {
	const navigate = useNavigate();
	const dispatch = useDispatch();
	const location = useLocation();

	const activeScenario = getScenarioNumByPath(location.pathname);

	return (
		<div className="h-100">
			<div className="container-fluid h-100">
				<div className="row h-100">
					{/* Columna izquierda: texto y botón */}
					<div
						className="col-md-5 d-flex justify-content-start align-items-center ps-5 pt-5"
						style={{ marginBottom: "2vh" }}
					>
						<div className="d-flex flex-column align-items-start mt-6 w-100">
							<h3 className="txt42 txt-purple bold w-100">
								Presentación de resultados
							</h3>
							<p
								className="position-relative txt24 mt-2"
								style={{
									padding: "20px",
									lineHeight: "1.6",
									border: "1px solid #ffcdd0ba",
									borderRadius: "8px",
									overflow: "hidden",
								}}
								>
								Con la evaluación completa y las decisiones clínicas fundamentadas en la evidencia, se concluye la atención de Manuel. Cada paso en su cuidado ha permitido consolidar tus habilidades de análisis y toma de decisiones, reforzando la importancia de un abordaje integral y reflexivo en la práctica clínica.

								{/* Icono decorativo */}
								<IconActivity
									size={100}
									color="#000"
									stroke={1}
									className="position-absolute"
									style={{
									top: "0px",
									right: "0px",
									opacity: 0.1,
									pointerEvents: "none",
									}}
								/>
							</p>

							<div className="mt-3 w-100">
								<NextButton
									navigateTo={ROUTES.SCENARIO5_FIN}
									activeScenario={activeScenario}
									color="green"
								/>
							</div>
						</div>
					</div>

					{/* Columna derecha: video */}
					<div className="col-md-7 d-flex justify-content-center align-items-center">
						<video
							autoPlay
							loop
							muted
							playsInline
							className="rounded shadow"
							style={{ maxWidth: "90%", borderRadius: "12px" }}
						>
							<source src={videopacientefrente} type="video/mp4" />
							Tu navegador no soporta video HTML5.
						</video>
					</div>
				</div>
			</div>

			{/* Barra inferior */}
			<ScenarioBar activeScenario={activeScenario} />
		</div>
	);
}

export default injectIntl(Scenario5Intro);
